import { render, staticRenderFns } from "./DepartmentManagement.vue?vue&type=template&id=5c66dfcb&scoped=true"
import script from "./DepartmentManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentManagement.vue?vue&type=script&lang=js"
import style0 from "./DepartmentManagement.vue?vue&type=style&index=0&id=5c66dfcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66dfcb",
  null
  
)

export default component.exports